import { MAX_BATCH_RULES } from './expandVehicleRuleSelections';

const ruleCount = (n: number): string => `${n} rule${n === 1 ? '' : 's'}`;

export function batchCountMessage(count: number): string {
    return count > MAX_BATCH_RULES
        ? `This would create ${ruleCount(count)}; the limit is ${MAX_BATCH_RULES} per save.`
        : `This will create ${ruleCount(count)}`;
}

export function batchResultMessage(created: number, skipped: number): string {
    return `Added ${ruleCount(created)}${skipped > 0 ? `, ${skipped} already existed` : ''}`;
}
